import Vue, { CreateElement } from '@src/vue'
import { Component, Prop } from 'vue-property-decorator'

import { Caption } from '@src/elements/typography/typography'
import { Icon } from '@src/elements/icon/icon'
import { noop } from '@src/util/noop'
import { Tooltip } from '@src/elements/tooltip/tooltip'
import { Popover } from '@src/components/popover/popover'
import { OptionGroup } from '@src/elements/select/option-group'
import { MenuButton } from '@src/elements/button/button'
import './position-changer.sass'

@Component
export class PositionChanger extends Vue {

  @Prop({ required: true })
  position: number

  @Prop({ required: true })
  total: number

  @Prop({ required: true })
  changePosition: (newPosition: number) => void

  render (h: CreateElement) {
    let availablePositions: any[] = []
    for (let i = 1; i <= this.total; i++) {
      if (i !== this.position) {
        availablePositions.push(<div onClick={() => this.changePosition(i)} ref={`position${i}`}>{i}</div>)
      }
    }

    return (<div class='position-changer'>
      <Tooltip content={this.$t('PAGE.CONTENT.WORKOUT.MOVE_UP').toString()}>
        <div class={`top ${this.position === 1 ? 'disabled' : ''}`}><Icon name='util/caret-up' click={this.position !== 1 ? () => this.changePosition(this.position - 1) : noop} /></div>
      </Tooltip>

      <Caption class='position'>
        {this.total === 1 ? this.position
          : <MenuButton>
            <div slot='button'>{this.position}</div>
            <Popover>
              <OptionGroup>
                {availablePositions}
              </OptionGroup>
            </Popover>
          </MenuButton>}
      </Caption>

      <Tooltip content={this.$t('PAGE.CONTENT.WORKOUT.MOVE_DOWN').toString()}>
        <div class={`bottom ${this.position === this.total ? 'disabled' : ''}`}>
          <Icon name='util/caret-down' click={this.position !== this.total ? () => this.changePosition(this.position + 1) : noop} /></div>
      </Tooltip>
    </div>)
  }
}
